<ul class="start-center flex-row">
    @for (bc of breadcrumbs; track bc; let isLast = $last) {
        <li class="start-center flex-row">
            <span>/</span>
            @if (!isLast) {
                <a href="{{ bc.url }}" (click)="navigate($event, bc)"> {{ bc.label }} </a>
            }
            @if (isLast) {
                <a class="crumbActive"> {{ bc.label }} </a>
            }
        </li>
    }
    <span class="flex"></span>
    <li class="end-center flex-row">
        <a
            href="https://classicgroupnz.sharepoint.com/sites/HubNotifications/SitePages/All-release-notes.aspx"
            target="_blank"
        >
            Current version: {{ environment.buildVersion }}
        </a>
    </li>
</ul>
